module.exports = __webpack_public_path__ + "img/horizontal_6_5_9006.4cb27563.png";